// Switch API: 'staging' = local Laravel | 'production' = live server
const flag = 'production';

const env = {
  staging: {
    BACKEND_URL: 'http://127.0.0.1:8000',
    BACKEND_STORAGE_URL: 'http://127.0.0.1:8000/storage',
    API_URL: 'http://127.0.0.1:8000/api',
  },
  production: {
    BACKEND_URL: 'https://api.agentmarketfinder.com/',
    BACKEND_STORAGE_URL: 'https://api.agentmarketfinder.com/storage',
    API_URL: 'https://api.agentmarketfinder.com/api',
  },
};

const config = env[flag] || env.staging;

export default {
  ...config,
  flag,
};
